// LandingPage · sitio institucional
// Compartida por el modo SaaS (ruta /sitio) y el modo estático (build para
// SiteGround). Extraída de App.js para no arrastrar dependencias de auth
// dentro del bundle estático.

import React, { useCallback, useEffect, useState } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import Hero from '@/components/sections/Hero';
import Problema from '@/components/sections/Problema';
import Beneficios from '@/components/sections/Beneficios';
import ComoFunciona from '@/components/sections/ComoFunciona';
import Piloto from '@/components/sections/Piloto';
import Contacto from '@/components/sections/Contacto';
import CookieBanner from '@/components/CookieBanner';
import LegalModal from '@/components/LegalModal';
import Privacidad from '@/components/sections/Privacidad';
import Terminos from '@/components/sections/Terminos';

export default function LandingPage() {
  const [legal, setLegal] = useState(null); // 'privacidad' | 'terminos' | null

  const openLegal = useCallback((which) => setLegal(which), []);
  const closeLegal = useCallback(() => setLegal(null), []);

  // Abre el modal correspondiente si la URL trae hash #privacidad o #terminos.
  useEffect(() => {
    const applyHash = () => {
      const h = (window.location.hash || '').replace('#', '');
      if (h === 'privacidad' || h === 'terminos') setLegal(h);
    };
    applyHash();
    window.addEventListener('hashchange', applyHash);
    return () => window.removeEventListener('hashchange', applyHash);
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Problema />
        <Beneficios />
        <ComoFunciona />
        <Piloto />
        <Contacto onOpenLegal={openLegal} />
      </main>
      <Footer onOpenLegal={openLegal} />
      <WhatsAppFloat />

      <CookieBanner onOpenPrivacidad={() => openLegal('privacidad')} />

      <LegalModal
        open={legal === 'privacidad'}
        title="Política de Privacidad"
        onClose={closeLegal}
        testId="modal-privacidad"
      >
        <Privacidad />
      </LegalModal>

      <LegalModal
        open={legal === 'terminos'}
        title="Términos y Condiciones"
        onClose={closeLegal}
        testId="modal-terminos"
      >
        <Terminos />
      </LegalModal>
    </div>
  );
}
